import React from "react";
import {
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";
import PropTypes from "prop-types";
import { t } from "../../../utils/utils";

const ConfirmationModal = ({
  size,
  isOpen,
  closeAction,
  primaryAction,
  title,
  primaryButtonText,
  closeButtonText,
  primaryActionInProcess,
  children
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={closeAction}
      size={size}
      contentClassName="confirmation-modal"
      centered
    >
      <ModalHeader>{title}</ModalHeader>
      {children && <ModalBody>{children}</ModalBody>}
      <ModalFooter>
        <Col xs="9" md="5" className="mx-auto">
          <Button
            block
            color="primary"
            disabled={primaryActionInProcess}
            onClick={primaryAction}
          >
            {primaryActionInProcess ? t("procesando...") : primaryButtonText}
          </Button>
        </Col>
        <Col xs="9" md="5" className="mx-auto">
          <Button block color="secondary" onClick={closeAction}>
            {closeButtonText}
          </Button>
        </Col>
      </ModalFooter>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  size: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  description: PropTypes.string,
  primaryAction: PropTypes.func,
  primaryActionInProcess: PropTypes.bool.isRequired,
  primaryButtonText: PropTypes.string,
  closeAction: PropTypes.func.isRequired,
  closeButtonText: PropTypes.string,
  children: PropTypes.any
};

ConfirmationModal.defaultProps = {
  size: "md",
  primaryButtonText: "Confirmar",
  closeButtonText: "Cancelar",
  primaryActionInProcess: false
};

export default ConfirmationModal;
